import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { Home, Car, Wrench, CalendarDays, Wallet, User, LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const NAV = [
  { to: "/app", label: "Accueil", icon: Home, testId: "nav-home", end: true },
  { to: "/app/vehicules", label: "Véhicules", icon: Car, testId: "nav-vehicles" },
  { to: "/app/entretien", label: "Entretien", icon: Wrench, testId: "nav-maintenance" },
  { to: "/app/calendrier", label: "Calendrier", icon: CalendarDays, testId: "nav-calendar" },
  { to: "/app/budget", label: "Budget", icon: Wallet, testId: "nav-budget" },
  { to: "/app/profil", label: "Profil", icon: User, testId: "nav-profile" },
];

export default function Layout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const onLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <div className="min-h-screen bg-background pb-24 md:pb-0">
      <header className="sticky top-0 z-50 backdrop-blur-xl bg-white/80 border-b border-slate-200">
        <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
          <NavLink to="/app" className="flex items-center gap-2" data-testid="brand-link">
            <span className="h-9 w-9 rounded-xl bg-blue-600 text-white grid place-items-center">
              <Wrench className="h-5 w-5" />
            </span>
            <span className="font-display font-bold text-lg tracking-tight text-slate-900">
              Mon Entretien Auto
            </span>
          </NavLink>
          <nav className="hidden md:flex items-center gap-1">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.end}
                data-testid={`${n.testId}-desktop`}
                className={({ isActive }) =>
                  `px-3 py-2 rounded-full text-sm font-medium transition-colors ${
                    isActive ? "bg-blue-50 text-blue-700" : "text-slate-600 hover:bg-slate-100"
                  }`
                }
              >
                {n.label}
              </NavLink>
            ))}
            <button
              onClick={onLogout}
              data-testid="logout-btn-desktop"
              className="ml-2 inline-flex items-center gap-1.5 text-sm font-medium text-slate-500 hover:text-red-600 transition-colors"
            >
              <LogOut className="h-4 w-4" /> Déconnexion
            </button>
          </nav>
          <span className="md:hidden text-xs font-semibold text-slate-500 truncate max-w-[35%]">
            {user?.name}
          </span>
        </div>
      </header>

      <main className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <Outlet />
      </main>

      <nav className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-xl border-t border-slate-200">
        <div className="grid grid-cols-6">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              data-testid={n.testId}
              className={({ isActive }) =>
                `flex flex-col items-center gap-1 py-2.5 text-[10px] font-semibold transition-colors ${
                  isActive ? "text-blue-600" : "text-slate-500"
                }`
              }
            >
              <n.icon className="h-5 w-5" />
              {n.label}
            </NavLink>
          ))}
        </div>
      </nav>
    </div>
  );
}
